<template>
  <div>
    <div>
      <el-table :data="data" ref="sortTable" :cell-style="rowStyle" :summary-method="getSummaries" show-summary
        style="width: 100%;overflow: none;z-index:1" class="copy" @sort-change="sortChangeEvt">
        <el-table-column prop="id" label="素材" width="180" align="center" sortable="custom">
          <template slot-scope="props">
            <el-image :src="props.row.thumb" class="img_box"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="total" width="200" label="ID" align="left" sortable="custom" label-class-name="source_ID" >
          <template slot-scope="props">
              <span style="width:55px;display:flex;text-align: left;margin-left:35px;" >{{ props.row.source_id }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="create_time" width="200" label="上传日期" align="center" sortable="custom">
          <template slot-scope="props">
            <span style="width:80px;display:flex;text-align: left;margin-left:35px;" >{{ props.row.create_time }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="review" width="200" label="访问数量" align="center" sortable="custom">

        </el-table-column>
        <el-table-column prop="download_num" width="200" label="下载数量" align="center" sortable="custom">
          <template slot-scope="props">
            <span :style="{ color: props.row.download_num == 0 ? '#d1d1d1' : '#333' }">
              {{ props.row.download_num }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="last_download" width="200" label="最后下载" align="center" sortable="custom">
          <template slot-scope="props">
            <span :style="{ color: props.row.last_download == 0 ? '#d1d1d1' : '#333' }">
              {{ props.row.last_download }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="favorite" width="200" label="收藏数量" align="center" sortable="custom">
          <template slot-scope="props">
            <span :style="{ color: props.row.favorite == 0 ? '#d1d1d1' : '#333' }">
              {{ props.row.favorite }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount3" width="200" label="图片精度" align="center" sortable="custom">
          <template slot-scope="props">
            <span> {{ props.row.width + "*" + props.row.height }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="size" label="文件大小" align="left" sortable="custom">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["data", "num"  ],
    data() {
      return {
        header: true,
        src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        footer: "150px",
        table__header: "198px",
        table__body: "189px",
        //查询数据
        checkInput: "",

        //序列前后数据
        behindOrderInput: "",
        frontOrderInput: "",
        //选择作者数据
        authorInput: "",
        //分页输入框数据
        paginationInput: 10,
        currentPage1: 1,
        //分页总数据
        total: 100,
        pickerOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "本周",
              onClick(picker) {
                const current = new Date();
                let nowDayOfWeek = current.getDay();
                if (nowDayOfWeek === 0) nowDayOfWeek = 7;
                const dayNum = 1 * 24 * 60 * 60 * 1000;
                const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
                const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "当月",
              onClick(picker) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();
                let thisMonthStartDate = new Date(year, month, 1);
                let thisMonthEndDate = new Date(year, month + 1, 0);
                picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              },
            },
            {
              text: "当年",
              onClick(picker) {
                var tYear = new Date().getFullYear();
                var startTime = new Date(tYear, 0, 1); //当前年第一天
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
            {
              text: "昨天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit("pick", [start, start]);
              },
            },
            {
              text: "上周",
              onClick(picker) {
                const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
                let nowDayOfWeek = current.getDay();
                let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
                const firstDate = new Date(current.setDate(diffToMonday));
                const lastDate = new Date(current.setDate(diffToMonday + 6));
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "上月",
              onClick(picker) {
                var now = new Date();
                var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                var ed = new Date(now.getFullYear(), now.getMonth(), 0);
                picker.$emit("pick", [fd, ed]);
              },
            },
            {
              text: "去年",
              onClick(picker) {
                var tYear = new Date().getFullYear() - 1;
                var startTime = new Date(tYear, 0, 1);
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
          ],
        },
        value2: "",
        input: "",
        editShowInp: null,
        tableData: [],

      };
    },
    created() {
      this.$emit('sort-changed', this.sort);
    },

    methods: {
      cleanUpEvt() { },
      limitEvt() { },

      handleCurrentChange() { },
      //

      rowStyle({ row, column, rowIndex, columnIndex }) {
        //this.levelData='至尊会员'
        if (column.label == "等级") {
          return {
            background: "#ddf9ff",
          };
        } else if (column.label == "昵称") {
          return {
            background: "#f9ffdd",
          };
        }
      },
      // 列表排序 - 优化版（仅传递asc/desc，无空值）
        sortChangeEvt(row) {
          // 仅在有明确排序方向时才触发事件
          if (!row.order) return;

          const sortParams = {
            orWhere: row.prop,
            // 直接映射排序方向，排除空值情况
            order: row.order === 'ascending' ? 'asc' : 'desc'
          };

          this.$emit('Min_BOX', sortParams);
        },

      //显示修改输入框
      editShowEvt(e) {
        this.editShowInp = e.id;
        this.$nextTick((_) => {
          this.$refs.editInput.$refs.input.focus();
        });
      },
      editInpBlurEvt() {
        this.editShowInp = null;
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          for (let key in this.$props.num) {
            if (column.property == key) {
              sums[index] = this.$props.num[key];
            }
          }
        });
        return sums;
      },
    },
  };
</script>

<style lang="less" scoped>
  @import url("../style/space.less");
  @import url("../style/ps.less");

  
/deep/.el-table th.el-table__cell{
  background: #F5F7FA !important;
  padding: 0 !important;
}
/deep/.el-table__fixed-body-wrapper {
  overflow-y: scroll !important;
  height: calc(100vh - 205px) !important;
}
/deep/.el-table__fixed {
  height: calc(100% - -40px) !important;
}

  .search-box {
    width: calc(100% - 190px);
    min-width: 1200px;
    height: 90px;
    background: #fff;
    padding: 10px;
    position: fixed;
    top: 60px;
    z-index: 1123;
    visibility: inherit;
    /*box-shadow: 0px 10px 10px 1px rgba(226, 226, 226, 0.4);*/
    transition: all 0.8s ease 0.4s;
  }

  .search-box1 {
    height: 0;
    visibility: hidden;
  }

  .caoz {
    margin-top: 8px;
    display: flex;
  }

  .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 3%;
    transition: all 0.2s ease 0.5s;
  }

  .block1 {
    visibility: hidden;
  }

  .block1>div {
    display: none;
  }

  .all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    padding: 5px 20px;
    border-radius: 3px;
  }

  .demo-table-expand {
    background-color: #f2f2f2;
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 20px;
    width: 30%;
  }

  .name_box {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      cursor: pointer;
      display: none;
    }
  }

  .name_box:hover>i {
    display: block;
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: 135px;
    z-index: 111;
  }
  /*
  /deep/.el-table__body-wrapper {
    margin-top: var(--body);
  }

  /deep/.el-table__footer-wrapper {
    position: fixed;
    top: var(--footer);
    transition: all 1s ease 0.15s;
    z-index: 999;
  }

  /deep/.el-table__header-wrapper {
    position: fixed;
    top: var(--header);
    transition: all 1s ease 0.15s;
    z-index: 999;
  } */

  .rowClassOne {
    background-color: #e7ecff;
  }

  .rowClassTwo {
    color: #222222;
    background-color: #1c43ce;
  }

  .rowClassThree {
    background-color: #6a88f1;
  }

  /* 需要根据媒体查询更改的样式 */
  .main_header {
    display: flex;
    justify-content: space-between;
    height: 90px;
    position: fixed;
    width: 90%;
    z-index: 111;
  }

  /* 需要根据媒体查询更改的样式 */
  .changing-box {
    text-align: end;
  }

  /* 需要根据媒体查询更改的样式 */
  .main_center {
    min-width: 500px;
    display: flex;
    justify-content: end;
    margin-top: 10px;
    margin-right: 17px;
  }
  .span_box_one{
    position: absolute;
    z-index: 1;
    left:260px;
    top: 100px;
    font-size: 14px;
  }
  /deep/.el-table__body-wrapper {
    overflow-y: scroll !important;
    height: calc(100vh - 250px) ;
    overflow-x: scroll ;
  }

  .copy {
    margin-top: 48px;
  }

  /deep/.flex-images {
    width: 83.5%;
  }

 
  .img_box {
    width: 150px;
    height: 120px;
    /deep/.el-image__inner{
      object-fit: contain  ;
    }
  }
  /* 朝上排序样式 */
  /deep/.el-table .ascending .sort-caret.ascending{
    background-color: #f00 !important;
    background: url("../img/12.png" )no-repeat  -4px -3px  !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 58px;
    z-index: 11;
  }
  /* 朝下排序样式 */
  /deep/.el-table .descending .sort-caret.descending{
    background: url("../img/22.png" )no-repeat -5px 2px  !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 25px;

  }
  /deep/.el-table .descending .sort-caret.descending{
    border-top-color: #fff;
  }
  /* 朝上字体样式 */
  /deep/.el-table__header .ascending  .cell{
    color: #409EFF !important;
  }
  /* 朝下字体样式 */
  /deep/.el-table__header .descending  .cell{
    color: #409EFF !important;
  }

  @media screen and (min-width: 1920px) and (max-width: 2560px){
    /deep/.el-table__footer-wrapper {
      position: fixed !important;
      top: 120px !important;
    }
  }
  @media screen and (min-width: 2561px) and (max-width: 3440px){
    /deep/.el-table__footer-wrapper {
      position: fixed !important;
      top: 132px !important;
    }
  }
  /deep/.source_ID{
        text-indent: 20px !important;
    }

    @media screen and (min-width: 3241px)and (max-width: 3840px) {
      .copy{
        margin-top: 60px !important;
      }
    }

</style>




// WEBPACK FOOTER //
// src/components/psList.vue